module.exports = __webpack_public_path__ + "static/media/arrows-alt-h.0011749b.svg";